function cov_2jxgk8ieyg() {
  var path = "/app/src/components/long-term-content/components/subvention-faq-link/subvention-faq-link.tsx";
  var hash = "d2cbb58a245d1c702638301da3e8335f8a762fbc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/long-term-content/components/subvention-faq-link/subvention-faq-link.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 33
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 12
        },
        end: {
          line: 16,
          column: 23
        }
      },
      "2": {
        start: {
          line: 17,
          column: 19
        },
        end: {
          line: 17,
          column: 34
        }
      },
      "3": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 26,
          column: 3
        }
      },
      "4": {
        start: {
          line: 20,
          column: 16
        },
        end: {
          line: 23,
          column: 5
        }
      },
      "5": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 31
        }
      },
      "6": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 37,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 33
          },
          end: {
            line: 15,
            column: 34
          }
        },
        loc: {
          start: {
            line: 15,
            column: 55
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 19,
            column: 23
          }
        },
        loc: {
          start: {
            line: 19,
            column: 28
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 19
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d2cbb58a245d1c702638301da3e8335f8a762fbc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2jxgk8ieyg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2jxgk8ieyg();
import React from 'react';
import { Icon } from 'src/components/icon/icon';
import { Typography } from 'src/components/v2/typography';
import { useAppContext } from 'src/context/store/app-provider';
import { useLocale } from 'src/hooks/use-locale';
import { getSubventionFaqLink } from 'src/utils/get-subvention-faq-link';
import styles from './styles.css';
cov_2jxgk8ieyg().s[0]++;
export var SubventionFaqLink = function SubventionFaqLink(_ref) {
  var offer = _ref.offer;
  cov_2jxgk8ieyg().f[0]++;
  var t = (cov_2jxgk8ieyg().s[1]++, useLocale());
  var _ref2 = (cov_2jxgk8ieyg().s[2]++, useAppContext()),
    lang = _ref2.lang;
  cov_2jxgk8ieyg().s[3]++;
  var handleClick = function handleClick() {
    cov_2jxgk8ieyg().f[1]++;
    var faq = (cov_2jxgk8ieyg().s[4]++, getSubventionFaqLink(lang, offer.subventionCampaignId));
    cov_2jxgk8ieyg().s[5]++;
    window.open(faq, '_blank');
  };
  cov_2jxgk8ieyg().s[6]++;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('learn_more_about_this_offer')), /*#__PURE__*/React.createElement("div", {
    className: styles.arrowIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "arrow"
  })));
};